import { render, staticRenderFns } from "./contrastDetails.vue?vue&type=template&id=70b70d17"
import script from "./contrastDetails.vue?vue&type=script&lang=js"
export * from "./contrastDetails.vue?vue&type=script&lang=js"
import style0 from "./contrastDetails.vue?vue&type=style&index=0&id=70b70d17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports